import React from "react";
import { device, theme } from "../../../utils";
import styled from "styled-components";
import { INSTAGRAM_URL, TWITTER_URL, OPENSEA_URL } from "../../../constants";
import { FaInstagram } from "react-icons/fa";
import logo_instagram from '../../../assets/image/cult/social_instagram.png';
import logo_twitter from '../../../assets/image/cult/social_twitter.png';
import logo_foundation from '../../../assets/image/cult/social_foundation.png';
import logo_opensea from '../../../assets/image/cult/social_opensea.png';
import logo_discord from '../../../assets/image/cult/social_discord.png';

const ContentAboutWrap = styled.div`
    position: relative;

    // HEADER
    .content-header {
      margin-bottom: 10px;
      font-size: 18px;
      @media (max-width: 767px) { font-size: 16px; }
      text-shadow: 0 0 0 #000;
      cursor: pointer;
      text-align: center;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      max-width: 400px;
      width: 95%;
      display:none;

      @media ${device.sm} {
        font-size: 22px;
        @media (max-width: 767px) { font-size: 20px; }
        display: none;
      }

      @media ${device.md} {
        font-size: 25px;
        margin-bottom: 10px;
        display: none;
      }

      @media ${device.lg} {
        font-size: 28px;
        display: block;
      }

      &.cult-button {
        margin-bottom: 15px;
      }
    }


    .content-body {
      font-size: 14px;
      @media (max-width: 767px) { font-size: 12px; }
      padding: 0 5px;
      text-align: center;
      
      @media ${device.lg} {
        font-size: 18px;
        padding: 0 90px;
      }

      &.content-entry {
        @media ${device.md} {
          font-size: 20px;
        }
      }

      .content-image {
        width: 100%;
      }

      .text-bold {
        text-shadow: 0px 0px 1px #000;
      }

      &.drop-preview {
        font-size: 16px;
        @media (max-width: 767px) { font-size: 14px; }
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        padding: 15px 0;

        @media ${device.md} {
          font-size: 24px;
        }

        .cult-button {
          width: auto;
          max-width: 400px;
          font-size: 16px;
          @media (max-width: 767px) { font-size: 14px; }
          margin: 15px 0 10px;

          @media ${device.md} {
            font-size: 22px;
          }
        }

        // EXPERIMENT : instagram icon sitting to the left of the button —
        // the social_instagram.png is a solid, fully-opaque badge (no
        // transparent cutout around the glyph), so a mask can only clip to
        // its rounded-corner outline, not the icon shape. Using the real
        // vector icon from react-icons instead, colored flat to match
        // .cult-button-alt-colors (cultPalette[2]) via color + currentColor.
        .instagram {
          position: relative;
          top: 3px;
          flex: 0 0 auto;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          color: ${theme.cultPalette[2]};

          svg {
            width: 100%;
            height: 100%;
            transform: none;
          }

          @media ${device.md} {
            width: 44px;
            height: 44px;
          }

          &:hover {
            opacity: 0.6;
          }
        }
      }
    }

    .hide-medium {
        @media ${device.md} {
            display: none;
        }
    }

    // SOCIAL LINKS
    .content-link-wrap {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 95%;
      max-width: 400px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin: 15px 0 0;

      @media ${device.md} {
        margin: 10px 0 0;
      }
  
      a { 
        display: inline-flex;   
        width: 40px;
        height: 40px;
        font-size: 0;
        overflow: hidden;
        &.instagram { background: rgba(0, 0, 0, 0) url("${logo_instagram}") no-repeat scroll 50% 50% / contain; }
        &.twitter { background: rgba(0, 0, 0, 0) url("${logo_twitter}") no-repeat scroll 50% 50% / contain; }
        &.discord { background: rgba(0, 0, 0, 0) url("${logo_discord}") no-repeat scroll 50% 50% / contain; }
        &.foundation { background: rgba(0, 0, 0, 0) url("${logo_foundation}") no-repeat scroll 50% 50% / contain; }
        &.opensea { background: rgba(0, 0, 0, 0) url("${logo_opensea}") no-repeat scroll 50% 50% / contain; }

        @media ${device.md} {
          width: 60px;
          height: 60px;
        }
  
        &:hover {
          opacity: 0.6;
        }
      }
    }

    .content-no-nfts {
      font-size: 20px !important;
      margin-top: 10px;
      margin-bottom: 30px;
      pointer-events: none;

      @media ${device.md} {
        font-size: 30px !important;
      }
    }
  
    // UTIL
    .text-center {
      text-align: center;
    }
`;

class ContentAbout extends React.Component {
  render() {
    return (
      <ContentAboutWrap>
        <li className="content-header">.// CULT OF NEON \\.</li>
        {/* <li className="content-entry content-body text-center">Sentinels of the human realm, we monitor and catalog the luminous spirits that dwell within our world unseen. Humanitys' collective, emotional energy conjures these neon spirits, and we are stewards of the occultic archive.</li> */}
        <li className="content-entry content-body text-center">Secret Society of Underground Neon Galleries</li>
        {/* NEW DROP TEASER */}
        
          <li className="content-entry content-body text-center drop-preview">
            <a className="instagram" href={INSTAGRAM_URL} target="_blank" rel="noreferrer" aria-label="Instagram"><FaInstagram /></a>
            <a className="cult-button cult-button-alt-colors" href={INSTAGRAM_URL} target="_blank">:: FOLLOW FOR DROPS ::</a>
          </li>
          {/* <li className="content-body text-center">[ FOLLOW FOR ANNOUNCEMENTS ]</li>  */}

        {/* EXPERIMENT : instagram icon moved up into .drop-preview, left of the button
        <li className="content-link-wrap">
            <a className="twitter" href={TWITTER_URL} target="_blank" rel="noreferrer" aria-label="Twitter">Twitter</a>
            <a className="instagram" href={INSTAGRAM_URL} target="_blank" rel="noreferrer" aria-label="Instagram">Instagram</a>
            <a className="foundation" href={FOUNDATION_COLLECTION_URL}></a>
            <a className="opensea" href={OPENSEA_URL} target="_blank" rel="noreferrer" aria-label="OpenSea">OpenSea</a>
        </li>
        */}
      </ContentAboutWrap>
    );
  }
};

export default ContentAbout;